import React from "react";
import styled from "styled-components";

const Wrapper = styled("div")`
  margin-bottom: 20px;
`;
const StyledThankyouMessage = styled("h4")`
text-align: center;
color: ${props => props.color};
background: transparent;
padding: 10px;
padding: 10px 15px 10px;
border-radius: 10px;
margin-bottom:10px;
font-family: 'Poppins', sans-serif;
word-break: break-word;
a{
  color:blue !important;
  font-size: 16px;
    display: block;
    margin: 5px 0px;
    text-decoration: underline;
}
`
const StyledName = styled("p")`
font-size: 20px;
margin: 12px 0 2px;
text-transform: capitalize;
font-weight: 500;
color: #29562d;
font-style: italic;
font-family: 'Poppins', sans-serif;
text-align:center;
`
const Message = (props) => {
  const { luckyDraw } = props;

  const importAll = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  };

  const images = importAll(
    require.context("../../../images", false, /\.(png|jpe?g|svg)$/)
  );
  const { root, firstName, lastName } = props;
  const fullName = `${firstName ? firstName.trim() : ""} ${lastName ? lastName.trim() : ""}`;
  const message = root.eventTym ? root.eventTym : ""
  let finalMessage = message;
  if (message.match(/\bhttps?:\/\/\S+/gi) || message.match(/\bhttps?::\/\/\S+/gi)) {
    const url = message.match(/\bhttps?:\/\/\S+/gi) || message.match(/\bhttps?::\/\/\S+/gi)
    finalMessage = finalMessage.replace(url, `<a href='${url}' target='_blank'>${url}</a>`)
    finalMessage = `<div>` + finalMessage + `</div>`
  }

  return (
    <Wrapper>
      <StyledThankyouMessage color="black" style={{ textAlign: "center" }} dangerouslySetInnerHTML={{ __html: finalMessage }}></StyledThankyouMessage>
      <br />
      {luckyDraw != null && (
        <>
          {fullName && fullName.trim() != "" && <StyledName>{fullName}</StyledName>}
        </>
      )}
    </Wrapper>
  );
};

export default Message;
